"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConst = void 0;
var react_1 = require("react");
/**
 * @category Hook
 */
function useConst(initialValue) {
    var ref = (0, react_1.useRef)();
    if (ref.current === undefined) {
        ref.current = {
            value: typeof initialValue === "function" ? initialValue() : initialValue,
        };
    }
    return ref.current.value;
}
exports.useConst = useConst;
